<template>
    <modal :to="name">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-header">
                            <button aria-label="Close" class="button button-outline button-icon" @click="$root.toggleModal(name)" type="button">
                                <i class="fa fa-times"></i>
                            </button>
                            <slot name="header"></slot>
                        </div>

                        <div class="modal-body">
                            <slot name="body"></slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </modal>
</template>

<style lang="scss">
    .modal-header {
        h2 {
            margin-top: 0;
            font-size: 2rem;
            margin-bottom: 1rem;
            line-height: 1.1em;
            color: var(--color-purple-darker);
        }

        button {
            float: right;
            margin-left: .7rem;
            margin-bottom: .7rem;
        }

        .button-icon {
            width: 40px;
            height: 40px;
        }
    }

    .modal-body {
        figure {
            margin-bottom: 0;
        }

        img {
            max-width: 100%;
        }

        p {
            font-size: 1.1rem;
        }

        ol, ul {
            font-size: 1.1rem;
            padding-left: 1rem;

            li {
                margin: .5rem 0;
            }
        }

        .loading {
            text-align: center;
        }
    }

    @media (min-width: 768px) {
        .modal-header h2 {
            font-size: 2.4rem;
        }
    }
</style>

<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: var(--zindex-modal);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 90%;
        max-width: 700px;
        margin: 0px auto;
        padding: 20px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        max-height: 70vh;
        overflow-y: scroll;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-enter,
    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        transform: scale(1.1);
    }

    @media (min-width: 768px) {
        .modal-container {
            padding: 30px;
        }
    }
</style>

<script>
    import Modal from './Modal.vue'

    export default {
        props: {
            name: {
                type: String,
                required: true,
            }
        },
        components: {
            Modal,
        },
    }
</script>
